module.exports = function Divider() {

    return <div
        aria-hidden
        style={{
            width: '100%',
            height: 28,
            flexShrink: 0
        }}
    />;
};
